import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Toast } from 'antd-mobile';
import { LoginInfoStudent, requestStudent } from '../../services/login'
import { tokenStorage } from '../../utils/localStorageUtils';


export const fetchStudent = createAsyncThunk(
    'login/fetchStudent',
    async (userId, thunkAPI) => {
      const res = await requestStudent()
      return res;
    }
  )

const initialState: {
    loginInfoStudent?: LoginInfoStudent 
    alertLogin: boolean //是否弹出登录窗口
} = {
    alertLogin: false,
    loginInfoStudent: undefined
}

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {

        alertLogin: (state, action: PayloadAction<boolean>) => {
            // if(action.payload ){

            // }
            state.alertLogin = action.payload;
        },

        // loginInfoStudent: (state, action: PayloadAction<LoginInfoStudent>) => {
        //     state.loginInfoStudent = action.payload
        // }
    },

    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchStudent.fulfilled, (state, action) => {
            console.error("login -> extraReducers : ", action)
          // Add user to the state array
          if(action.payload.code == 1){
            state.alertLogin = false;
            state.loginInfoStudent = action.payload.data;
          }else{
            state.alertLogin = true;
            state.loginInfoStudent = undefined;
            tokenStorage.remove();
            //token过期
            // Toast.show({content: '获取用户信息失败',})
          }
         
        })
      },
})

// Action creators are generated for each case reducer function
export const { alertLogin } = loginSlice.actions
// export const selectCount = (state: RootState) => state.counter.value

export default loginSlice.reducer